module.exports = __webpack_public_path__ + "img/blue-white.e63df688.png";